export default "__VITE_ASSET__8jiohQUm__"